// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"clear-formatting-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M22.2739 11.5454L14.0312 3.30273L5.78857 11.5454L14.0312 19.788L22.2739 11.5454Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M5.78828 11.5454L14.0309 3.30273L22.2736 11.5454L14.0309 19.788M5.78828 11.5454L14.0309 19.788M5.78828 11.5454L3.78835 13.5456C2.61678 14.7171 2.61677 16.6166 3.78835 17.7882L7.16212 21.162L12.6572 21.162M14.0309 19.788L12.6572 21.162M12.6572 21.162H18.9998","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-clear-formatting-1')
export default class ClearFormatting1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'clear-formatting-1',
    }
  }
}
